__turbopack_context__.v({
  "avatar": "ReelPhone-module__yE12Ba__avatar",
  "avatarMono": "ReelPhone-module__yE12Ba__avatarMono",
  "bottom": "ReelPhone-module__yE12Ba__bottom",
  "caption": "ReelPhone-module__yE12Ba__caption",
  "card": "ReelPhone-module__yE12Ba__card",
  "follow": "ReelPhone-module__yE12Ba__follow",
  "frame": "ReelPhone-module__yE12Ba__frame",
  "metaLine": "ReelPhone-module__yE12Ba__metaLine",
  "muteBtn": "ReelPhone-module__yE12Ba__muteBtn",
  "notch": "ReelPhone-module__yE12Ba__notch",
  "rail": "ReelPhone-module__yE12Ba__rail",
  "railAudio": "ReelPhone-module__yE12Ba__railAudio",
  "railAudioMono": "ReelPhone-module__yE12Ba__railAudioMono",
  "railBtn": "ReelPhone-module__yE12Ba__railBtn",
  "reelspin": "ReelPhone-module__yE12Ba__reelspin",
  "stage": "ReelPhone-module__yE12Ba__stage",
  "track": "ReelPhone-module__yE12Ba__track",
  "uname": "ReelPhone-module__yE12Ba__uname",
  "user": "ReelPhone-module__yE12Ba__user",
  "video": "ReelPhone-module__yE12Ba__video",
  "viewport": "ReelPhone-module__yE12Ba__viewport",
});
